import { memo } from 'react';
import { Box, Stack } from '@mui/material';

// Components
import NavList from './NavList';

// Hooks
import { useRoles } from '@Hooks/shared/useRoles';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

// Types
import { NavSectionProps, NavListProps } from '../types';
import { RouteConfig } from '@Hooks/shared/useRoles';

// Styles
import Styles from './NavSectionMini.module.scss';

function NavSectionMini({ data }: NavSectionProps) {
  const { userPermissions } = useAuthorization();
  const { allRoutes } = useRoles();
  const { currentUser } = useAuthorization();
  const isAdmin = currentUser?.isSuper;

  const permissionedRoutes = isAdmin
    ? allRoutes
    : allRoutes?.filter((route: RouteConfig) => {
        const routePermissions = Array.isArray(route.routePermission)
          ? route.routePermission
          : // @ts-ignore
            route.routePermission?.split('||').map((perm: string) => perm.trim());

        return routePermissions?.some((perm: string) => userPermissions?.includes(perm));
      });

  return (
    <Stack className={Styles.NavSectionMini}>
      {data.map((group, index) => (
        <Items
          key={group.subheader}
          items={permissionedRoutes}
          isLastGroup={index + 1 === data.length}
        />
      ))}
    </Stack>
  );
}

export default memo(NavSectionMini);

type ItemsProps = {
  items: NavListProps[];
  isLastGroup: boolean;
};

function Items({ items, isLastGroup }: ItemsProps) {
  return (
    <>
      {items.map((list) => (
        <NavList key={list.title + list.path} data={list} depth={1} hasChild={!!list.children} />
      ))}

      {!isLastGroup && (
        <Box
          sx={{
            width: 24,
            height: '1px',
            bgcolor: 'divider',
            my: '8px !important',
          }}
        />
      )}
    </>
  );
}
